import { type Themes } from '@smart/web-foundations';
import '@smart/web-foundations/setup';
import React from 'react';
import { Theme } from '../theme/theme';

export type ComponentProviderProps = {
  locale?: string;
  theme?: Themes;
  children?: React.ReactNode;
};

export const ComponentProvider = ({
  theme,
  children,
}: ComponentProviderProps) => {
  return <Theme theme={theme}>{children}</Theme>;
};

ComponentProvider.displayName = 'ComponentProvider';
